/** Route paths for the "Saved Products & Cart" prototype. */
export const HOME_ROUTE = "/cc/saved-products-cart";
export const CART_ROUTE = "/cc/saved-products-cart/cart";
export const SAVED_PRODUCTS_ROUTE = "/cc/saved-products-cart/collections";
export const ALL_COLLECTIONS_ROUTE = "/cc/saved-products-cart/all-collections";
export const COLLECTION_DETAIL_ROUTE = `${SAVED_PRODUCTS_ROUTE}/:collectionId`;

export const collectionDetailRoute = (collectionId: string): string =>
  `${SAVED_PRODUCTS_ROUTE}/${collectionId}`;
